import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Header, Footer } from '@/components/Layout';
import { HomePage, PrivacyPage, FAQPage, TermsPage } from '@/pages';
import { getTheme } from './theme/theme';
import { ThemeModeProvider, useThemeMode } from '@/contexts/ThemeContext';
import { initAnalytics, trackPageView } from '@/utils/analytics';

function AnalyticsTracker() {
  const location = useLocation();

  // Инициализация Firebase Analytics
  useEffect(() => {
    initAnalytics();
  }, []);

  // Отслеживание смены страниц
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function AppContent() {
  const { mode } = useThemeMode();
  const theme = getTheme(mode);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AnalyticsTracker />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Header />
          <Box component="main" sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/privacy.html" element={<Navigate to="/privacy" replace />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/faq.html" element={<Navigate to="/faq" replace />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/term.html" element={<Navigate to="/terms" replace />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppContent />
    </ThemeModeProvider>
  );
}

export default App;
